import { render, staticRenderFns } from "./FooterPoint.vue?vue&type=template&id=28292aca&scoped=true"
import script from "./FooterPoint.vue?vue&type=script&lang=ts"
export * from "./FooterPoint.vue?vue&type=script&lang=ts"
import style0 from "./FooterPoint.vue?vue&type=style&index=0&id=28292aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28292aca",
  null
  
)

export default component.exports